import Phaser from 'phaser';
import { createWebPlatform } from '../platform/web';

/**
 * "Tap to start" screen. Its one job is to receive the first user gesture, which
 * iOS Safari requires before any audio can play (CLAUDE.md §5).
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('boot');
  }

  create(): void {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor('#1b2a1f');

    const title = this.add
      .text(width / 2, height / 2 - 40, 'Tusk and Bow', {
        fontSize: '48px',
        color: '#f2e8c9',
        fontFamily: 'sans-serif',
      })
      .setOrigin(0.5);
    const prompt = this.add
      .text(width / 2, height / 2 + 30, 'Tap to start', {
        fontSize: '28px',
        color: '#a8c9a0',
        fontFamily: 'sans-serif',
      })
      .setOrigin(0.5);

    this.scale.on('resize', (size: Phaser.Structs.Size) => {
      title.setPosition(size.width / 2, size.height / 2 - 40);
      prompt.setPosition(size.width / 2, size.height / 2 + 30);
    });

    this.input.once('pointerdown', () => {
      const platform = createWebPlatform(this.sound);
      platform.audio.unlock();
      this.registry.set('platform', platform);
      this.scene.start('game');
    });
  }
}
